import { defineComponent as _defineComponent } from 'vue'

  import Modal from "../Modal.vue";
  import ContactUsLink from "@/components/landing/ContactUsLink.vue";
  import { CALENDLY_BUILD_LINK } from "@/constants/calendlyLinks";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SuccessRequestReserveModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    house: {
      type: Object,
      required: true,
    },
  },
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emits = __emit;
  const onClose = () => {
    emits("close");
  };

const __returned__ = { props, emits, onClose, Modal, ContactUsLink, get CALENDLY_BUILD_LINK() { return CALENDLY_BUILD_LINK } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})